import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperComponent } from './stepper/stepper.component';
import { AccordionPlusCheckboxComponent } from './accordion-plus-checkbox/accordion-plus-checkbox.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { RadioBtnComponent } from './radio-btn/radio-btn.component';
import { SemaphoreCardComponent } from './semaphore-card/semaphore-card.component';
import { IconLabelComponent } from './icon-label/icon-label.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { AppInputTextComponent } from '@app/custom-shared/components/form/app-input-text/app-input-text.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomSharedModule } from '@app/shared/custom-shared.module';
import { AccordionComponent } from '@app/shared/components/accordion/accordion.component';
import { RadioButtonComponent } from '@app/shared/components/radio-button/radio-button.component';
import { AppInputCurrencyComponent } from '@app/custom-shared/components/form/app-input-currency/app-input-currency.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { TextMaskModule } from 'angular2-text-mask';
import { CurrencyMaskModule } from 'ng2-currency-mask';

@NgModule({
  declarations: [
    StepperComponent,
    AccordionPlusCheckboxComponent,
    RadioBtnComponent,
    SemaphoreCardComponent,
    IconLabelComponent,
    ButtonComponent,
    AppInputTextComponent,
    AppInputCurrencyComponent,
    AccordionComponent,
    RadioButtonComponent
  ],

  imports: [
    CommonModule,
    MatExpansionModule,
    MatRadioModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    CustomSharedModule,
    ReactiveFormsModule,
    CurrencyMaskModule
  ],
  exports: [
    StepperComponent,
    AccordionPlusCheckboxComponent,
    MatExpansionModule,
    MatRadioModule,
    MatCheckboxModule,
    RadioBtnComponent,
    SemaphoreCardComponent,
    IconLabelComponent,
    ButtonComponent,
    AppInputTextComponent,
    AppInputCurrencyComponent,
    AccordionComponent,
    RadioButtonComponent,
  ]
})
export class ComponentsModule { }